export function OnlineBookingFormHint({ children }: { children: React.ReactNode }) {
  return (
    <p className="rounded-lg border border-separator/80 bg-fill-quaternary px-3 py-2 text-xs text-label-secondary">
      {children}
    </p>
  );
}
